var map = {
	"./logo-bocconi.svg": 1383,
	"./logo-caltech.svg": 1384,
	"./logo-cambridge.svg": 1385,
	"./logo-edinburgh.svg": 1386,
	"./logo-oxford.svg": 1387,
	"./logo-texas.svg": 1388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;